import { ReactNode } from "react";
import { BaseInput } from "shared/components/forms/BaseInput";
import {
  OWNER_CONTACT_FIELDS,
  type OwnerContactField
} from "./ownerContactFields";

type OwnerContactRegister = (field: OwnerContactField) => {
  value: string;
  onChange: (value: string) => void;
  error?: string | boolean;
};

export const OwnerContactInputs = ({
  register,
  renderHint
}: {
  register: OwnerContactRegister;
  renderHint?: (field: OwnerContactField) => ReactNode;
}) => (
  <div className="grid grid-cols-2 gap-4 py-4">
    {OWNER_CONTACT_FIELDS.map(({ field, label, id, placeholder }) => (
      <div key={field} className="w-full space-y-1">
        <BaseInput
          id={id}
          label={label}
          placeholder={placeholder}
          {...register(field)}
        />
        {renderHint?.(field)}
      </div>
    ))}
  </div>
);
